import { MessageListWrapper } from './style';
import DateDivider from './DateDivider';
import Message from './Message';
import { TypingIndicator } from './TypingIndicator';
import { BOT_IDENTITY } from '../../../utils/constants';
import React, { useState } from 'react';
var MessageList = function (_a) {
    var identity = _a.identity, members = _a.members, messages = _a.messages, teamMember = _a.teamMember, userType = _a.userType;
    return (React.createElement(MessageListWrapper, null,
        (messages === null || messages === void 0 ? void 0 : messages.length) > 0 && renderMessageList(identity, members, messages, userType, teamMember),
        React.createElement(TypingIndicator, { identity: identity, members: members })));
};
var renderMessageList = function (identity, members, messages, userType, teamMember) {
    var filteredMessages = messages.filter(function (message) {
        var shouldHideBotMessageForTeamMember = userType === 'broker' && message.authorIdentity === BOT_IDENTITY;
        return !shouldHideBotMessageForTeamMember;
    });
    var _a = useState(-1), selectedIndex = _a[0], setSelectedIndex = _a[1];
    return filteredMessages.map(function (message, i) {
        var previousMessage = i > 0 ? filteredMessages[i - 1] : undefined;
        var nextMessage = i < messages.length - 1 ? filteredMessages[i + 1] : undefined;
        return (React.createElement("div", { key: i, onClick: function () { return (i === selectedIndex ? setSelectedIndex(-1) : setSelectedIndex(i)); } },
            React.createElement(DateDivider, { message: message, previousMessage: previousMessage }),
            React.createElement(Message, { key: message.index, identity: identity, previousMessage: previousMessage, message: message, nextMessage: nextMessage, members: members, teamMember: teamMember, isSelected: i === selectedIndex })));
    });
};
export default MessageList;
//# sourceMappingURL=index.js.map